module.exports = __webpack_public_path__ + "static/media/icon_arrow_left.b624fdc2.svg";